module.exports = __webpack_public_path__ + "img/chrome-review.0396aea8.png";